const DropDownForm = ({ children, title, about }) => {
  return (
    <>
      <details className="collapse collapse-plus bg-base-200 my-4 p-2 ">
        <summary className="collapse-title text-xl font-medium">
          {title}
        </summary>
        <div className="collapse-content">
          <p>{about}</p>
        </div>
        <div className="px-4">{children}</div>
      </details>
    </>
  );
};

export default DropDownForm;
